export const bpInfo = {version: 'v3.2.3'};
